module.exports = __webpack_public_path__ + "media/4x3/zm-a9ff495d.svg";